// extracted by mini-css-extract-plugin
export default {"addressAction":"w8-z","loading":"x8-z"};